import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./placed_students.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const getSlidesToShow = (width) => {
  if (width <= 480) return 1;
  if (width <= 1024) return 2;
  return 3;
};

const PlacedStudents = () => {
  const sliderRef = useRef(null);
  const [placedStudents, setPlacedStudents] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow(window.innerWidth));

  useEffect(() => {
    const fetchPlacedStudents = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/placed-students/public`);
        const data = await res.json();
        setPlacedStudents(data.placedStudents || []);
      } catch (err) {
        console.log(err);
      }
    };
    fetchPlacedStudents();
  }, []);

  useEffect(() => {
    const handleResize = () => setSlidesToShow(getSlidesToShow(window.innerWidth));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow,
    slidesToScroll: 1,
    arrows: slidesToShow > 1,
    pauseOnHover: false,
    initialSlide: 0,
  };

  return (
    <section className="main-section" id="placed-students-section">
      <h1 className="title">Our Placed Students</h1>
      <h2 className="subtitle">Celebrating the success of our graduates</h2>

      <div className="placed-students">
        <Slider
          key={slidesToShow}
          ref={sliderRef}
          className="placed-students-carousel"
          {...settings}
          onMouseEnter={() => sliderRef.current?.slickPause()}
          onMouseLeave={() => sliderRef.current?.slickPlay()}
        >
          {placedStudents.map((student) => (
            <div key={student.id}>
              <div
                className="placed-student-card"
                style={{ backgroundImage: `url(/assets/images/about/manet_building.webp)` }}
              >
                <div className="student-photo-container">
                  {student.student_photo ? (
                    <img
                      src={`${API_BASE}${student.student_photo}`}
                      alt={student.student_name}
                      className="student-photo"
                    />
                  ) : (
                    <div className="student-photo-placeholder">
                      {student.student_name.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="student-info">
                  <h3 className="student-name">{student.student_name}</h3>
                  <p className="student-text">{student.course}</p>
                  <p className="student-text">{student.company_name}</p>
                  <p className="student-text">{student.passout_year}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default PlacedStudents;
